module.exports = __webpack_public_path__ + "img/vk.c9a59cab.svg";